import React from 'react'
// import {Navbar} from '@components/ai'
import SiteHeader from '@components/SiteHeader'
import {AISolutionContact} from './AISolutionContact'
import SiteFooter from '@components/SiteFooter'

type Props = {
  children: React.ReactNode
}

export const AISolutionDetailLayout = ({children}: Props) => {
  return (
    <div>
      {/* <Navbar /> */}
      <SiteHeader />
      <div className='AISolutionDetail'>
        {children}

        <footer className='AISolutionDetail__footer'>
          <div className='container'>
            <p>
              <strong>Data Wow</strong> พร้อมนำเทคโนโลยีอย่าง AI
              เข้ามาช่วยเพิ่มประสิทธิภาพให้กับธุรกิจของคุณ
              เรามีทีมที่เชี่ยวชาญด้านเทคโนโลยีในหลากหลายอุตหกรรมที่สามารถออกแบบ{' '}
              <span>
                Customised AI Solution ให้ตรงกับความต้องการของธุรกิจคุณ
              </span>
            </p>

            <p>
              <strong>
                เรามอบการดูแลอย่างดีที่สุดตั้งแต่ต้นจนจบเพื่อประสิทธิภาพของธุรกิจอย่างยั่งยืน
              </strong>
            </p>
          </div>
        </footer>
      </div>

      <AISolutionContact />

      <SiteFooter />
    </div>
  )
}
